import { render, staticRenderFns } from "./Surrender.vue?vue&type=template&id=b6db4282&scoped=true"
import script from "./Surrender.vue?vue&type=script&lang=js"
export * from "./Surrender.vue?vue&type=script&lang=js"
import style0 from "./Surrender.vue?vue&type=style&index=0&id=b6db4282&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6db4282",
  null
  
)

export default component.exports